import { Data } from '@blade/std-lib'

import { Error } from '../core'

import { AuthErrorCode } from './api-error-code'

export class ApiError<Code extends string = string> extends Data.TaggedError(
  'ApiError',
)<{
  code: Code
  message?: string
}> {}

export const ofCode = <const T extends string>(code: T): ApiError<T> =>
  new ApiError({ code, message: '' })

export const is = (error: unknown): error is ApiError => {
  return error instanceof ApiError
}

export const isOfCode =
  <const Code extends string>(code: Code) =>
  (error: { _tag: string }): error is ApiError<Code> => {
    return is(error) && error.code === code
  }

export const isOfCodes =
  <const Codes extends Array<string>>(codes: Codes) =>
  (error: { _tag: string }): error is ApiError<Codes[number]> => {
    return is(error) && codes.includes(error.code)
  }

export const fallbackToUnknown = Error.UnknownError.fallbackToUnknown<
  ApiError | Error.UnknownError
>

export const isUnauthorizedOrExpired = (
  error: ApiError | Error.UnknownError,
): boolean => {
  return isOfCodes([AuthErrorCode.Unauthorized, AuthErrorCode.InvalidToken])(
    error,
  )
}
